import api from "./BaseServices";

export interface User {
  id: number;
  username: string;
  email: string;
  profile_picture_file?: Blob;
  profile_picture_url?: string;
  banner_image_file?: Blob;
  banner_image_url?: string;
  description: string;
  role: string;
}

// API base URL (replace with your backend API base URL)
const API_URL = `${process.env.REACT_APP_API_URL}/users`; // Modify this if your API is on a different URL

// Function to fetch all preferences with pagination (limit and offset)
export const updateUser = async (
  user: Partial<
    Omit<User, "id" | "created_at" | "updated_at" | "last_connection">
  >
): Promise<User> => {
  const response = await api.put(API_URL, user, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

  return response.data;
};

export const updateEmail = async (email: string): Promise<boolean> => {
  const response = await api.put(
    `${API_URL}/email`,
    { email },
    { withCredentials: true }
  );

  return response.data;
};

export const updatePassword = async (
  oldPassword: string,
  newPassword: string
): Promise<boolean> => {
  const response = await api.put(
    `${API_URL}/password`,
    { oldPassword, newPassword },
    { withCredentials: true }
  );

  return response.data;
};

export const getUserFromUsername = async (username: string): Promise<User> => {
  const response = await api.get(`${API_URL}/username/${username}`);
  return response.data;
};

export const checkUsername = async (username: string): Promise<boolean> => {
  const response = await api.get(`${API_URL}/username/${username}/check`);
  return response.status === 200;
};
